import React, { useEffect, useState, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import base_url from './config/Config';
import Sidebar from './components/Sidebar';
import Navigation from './components/Navigation';
import { FaEyeSlash } from 'react-icons/fa';
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner'; // Import Spinner component
import PageLoader from './components/PageLoader';

const OverDue = () => {
    const [overDue, setOverDue] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingPaid, setIsDownloadingPaid] = useState(false);
    const [isDownloadingAll, setIsDownloadingAll] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    // const [filteredOverDue, setFilteredOverDue] = useState([]);

  const overDuePerPage = 50;
    //    Pemisiion privillages atart 

    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]));
    }, []);

    // Permission check helper
    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete; // using canDelete for download
            default: return false;
        }
    }, [permissions]);
    //    Pemisiion privillages end



    // const getAllOverDue = () => {
    //     axios.get(`${base_url}/api/overdues/list`).then(
    //         (response) => {
    //             console.log(response.data);
    //             setOverDue(response.data);
    //         },
    //         (error) => {
    //             console.log(error);
    //         }
    //     );

    // };

    // useEffect(() => {
    //     getAllOverDue();
    // }, []);

    // ✅ Memoize the function so it doesn't get recreated on every render
    const getAllOverDue = useCallback(() => {
        if (!hasPermission('Overdue', 'view')) return;
        axios.get(`${base_url}/api/overdues/list`)
            .then((response) => {
                console.log(response.data);
                setOverDue(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => setPageLoading(false));
    }, [hasPermission]); // 👈 dependencies (none here, unless you use token or permissions later)

    // ✅ Safe effect
    useEffect(() => {
        getAllOverDue();
    }, [getAllOverDue]);

    // export excel function  start 

    // pending overdue  start
    const handleExportOverDue = async () => {
        if (!hasPermission('Overdue', 'download')) {
            alert('You do not have permission to download Over Due.');
            return;
        }
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api/export/pendingOverdues`, {
                responseType: 'blob' // This is important to handle binary data
            });

            // Create a link element
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Over_Due_data.xlsx'); // Specify the file name here

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);

            console.log('Export OverDue successfully:', response.data);
            alert('Export OverDue successfully');
        } catch (error) {
            console.error('Error generating OverDue:', error.response?.data || error.message);
            alert('Export OverDue not shown');
        } finally {
            setIsDownloading(false);
        }
    };


    // paid overdue  start
    const handleExportPaidOverDue = async () => {
        if (!hasPermission('Overdue', 'download')) {
            alert('You do not have permission to download Over Due.');
            return;
        }
        setIsDownloadingPaid(true);
        try {
            const response = await axios.get(`${base_url}/api/export/paidOverdues`, {
                responseType: 'blob' // This is important to handle binary data
            });

            // Create a link element
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Paid_Over_Due_data.xlsx'); // Specify the file name here

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);

            console.log('Export Paid OverDue successfully:', response.data);
            alert('Export Paid OverDue successfully');
        } catch (error) {
            console.error('Error generating OverDue:', error.response?.data || error.message);
            alert('Export paid OverDue not shown');
        } finally {
            setIsDownloadingPaid(false);
        }
    };

    // all overdue  start
    const handleExportAllOverDue = async () => {
        if (!hasPermission('Overdue', 'download')) {
            alert('You do not have permission to download Over Due.');
            return;
        }
        setIsDownloadingAll(true);
        try {
            const response = await axios.get(`${base_url}/api/export/allOverdues`, {
                responseType: 'blob' // This is important to handle binary data
            });

            // Create a link element
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'All_Over_Due_data.xlsx'); // Specify the file name here

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);

            console.log('Export All OverDue successfully:', response.data);
            alert('Export All OverDue successfully');
        } catch (error) {
            console.error('Error generating All OverDue:', error.response?.data || error.message);
            alert('Export All OverDue not shown');
        } finally {
            setIsDownloadingAll(false);
        }
    };



    
    // ✅ Search Filter Logic (same as your repayment page)
    const handleSearch = (event) => {
        event.preventDefault();
        let filtered = [...overDue];

        if (searchOption && searchInput) {
            switch (searchOption) {
                case 'borrower_name':
                    filtered = filtered.filter(item =>
                        item.customerName?.toLowerCase().includes(searchInput.toLowerCase())
                    );
                    break;
                case 'loan_id':
                    filtered = filtered.filter(item =>
                        item.overdue.loanId?.toString() === searchInput
                    );
                    break;
                case 'customer_id':
                    filtered = filtered.filter(item =>
                        item.overdue.customerId?.toString() === searchInput
                    );
                    break;
                case 'phone':
                    filtered = filtered.filter(item =>
                        item.phoneNumber?.toString().includes(searchInput)
                    );
                    break;
                default:
                    break;
            }
        }

        setOverDue(filtered);
        setCurrentPage(1);
    };


    const indexOfLastOverDue = currentPage * overDuePerPage;
    const indexOfFirstOverDue = indexOfLastOverDue - overDuePerPage;
    const overDues = overDue.slice(indexOfFirstOverDue, indexOfLastOverDue);
    const totalPages = Math.ceil(overDue.length / overDuePerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();


    // export excel function  end       
    if (!hasPermission('Overdue', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
            </div>
        );
    }
    return (
        <>
            <div className='overviewsaa'>
                <h4>Over Due</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form  onSubmit={handleSearch}>
                                            <div className='row'>
                                               <div className="col-md-2">
                                                    <select
                                                        className="form-control"
                                                        value={searchOption}
                                                        onChange={(e) => setSearchOption(e.target.value)}
                                                    >
                                                        <option value="">Search By</option>
                                                        <option value="borrower_name">Borrower Name</option>
                                                        <option value="loan_id">Loan ID</option>
                                                        <option value="customer_id">Customer ID</option>
                                                        <option value="phone">Phone Number</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-1">
                                                    <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                </div>
                                                {/* pending overdue start  */}

                                                <div className='col-md-2 mt-2'>
                                                    <div className='export'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportOverDue}
                                                            disabled={isDownloading || !hasPermission('Overdue', 'download')}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Pending Download
                                                                </>
                                                            )}
                                                        </NavLink>
                                                        {/* <Link to="#" className="btn btn-sm btn-primary" onClick={handleExportOverDue}>Export</Link> */}
                                                    </div>
                                                </div>

                                                {/* paid overdue start  */}

                                                <div className='col-md-2 mt-2'>
                                                    <div className='export'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportPaidOverDue}
                                                            disabled={isDownloadingPaid || !hasPermission('Overdue', 'download')}>
                                                            {isDownloadingPaid ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Paid Download
                                                                </>
                                                            )}
                                                        </NavLink>
                                                        {/* <Link to="#" className="btn btn-sm btn-primary" onClick={handleExportOverDue}>Export</Link> */}
                                                    </div>
                                                </div>

                                                {/* all overdue start  */}

                                                <div className='col-md-2 mt-2'>
                                                    <div className='export'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportAllOverDue}
                                                            disabled={isDownloadingAll || !hasPermission('Overdue', 'download')}>
                                                            {isDownloadingAll ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    All Download
                                                                </>
                                                            )}
                                                        </NavLink>
                                                        {/* <Link to="#" className="btn btn-sm btn-primary" onClick={handleExportOverDue}>Export</Link> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12 mb-5 mt-3'>
                                    <div className='allcustomer table-responsive table-striped'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : overDues.length > 0  ? (
                                            <table className="styled-table">
                                                <tbody>
                                                    <tr>
                                                        <th>S.N.</th>
                                                        <th>Phone_Number</th>
                                                        <th>Customer_Name</th>
                                                        <th>Repayment_Id</th>
                                                        <th>Loan_Id</th>
                                                        <th>Customer_Id</th>
                                                        <th>EMI_Due_Date</th>
                                                        <th>EMI_Number</th>
                                                        <th>EMI_Amount</th>
                                                        <th>Principal</th>
                                                        <th>Interest</th>
                                                        <th>Create_Date</th>
                                                        <th>Update_Date</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {overDues.map((data, index) => {
                                                        const overdue = data.overdue; // use the new overdue structure
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{data.phoneNumber}</td>
                                                                <td>{data.customerName}</td>
                                                                <td>{overdue.id}</td>
                                                                <td>{overdue.loanId}</td>
                                                                <td>{overdue.customerId}</td>
                                                                <td>{overdue.dueDate}</td>
                                                                <td>{overdue.installmentNumber}</td>
                                                                <td>{overdue.emiAmount}</td>
                                                                <td>{overdue.principal}</td>
                                                                <td>{overdue.interest}</td>
                                                                <td>{overdue.createDate ? new Date(overdue.createDate).toLocaleDateString() : ''}</td>
                                                                <td>{overdue.updateDate ? new Date(overdue.updateDate).toLocaleDateString() : ''}</td>
                                                                <td style={{ color: overdue.emiStatus === 1 ? 'green' : overdue.emiStatus === 0 ? 'black' : 'red', fontWeight: '700' }}>
                                                                    {overdue.emiStatus === 0 ? 'Pending' : overdue.emiStatus === 1 ? 'Paid' : 'Unknown'}
                                                                </td>
                                                                <td className='iconss'>
                                                                    {hasPermission('Overdue', 'view') ? (
                                                                        <NavLink to={`/loanmaster/ViewLoan?customerId=${overdue.customerId}&loanId=${overdue.loanId}`}>
                                                                            <FaEyeSlash />
                                                                        </NavLink>
                                                                    ) : (
                                                                        <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No OverDue"
                                        )}

                                    </div>
                                      <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OverDue;
